import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger)

$.fn.HorizontalVeggies = function() {
  let self = this
  let horizontalVeggiesInitiated = false;

  self.initHorizontalVeggies = function() {
    if (!$.mlmi.mobile.isMobile) {
      if (!horizontalVeggiesInitiated) {
        horizontalVeggiesInitiated = true;
          var steps = self.find('.grid__item').length;
          ScrollTrigger.create({
            trigger: self,
            pin: true,
            start: "center center",
            end: "+=" + steps * 300 + " center",
            anticipatePin: 1,
            toggleClass: "--animate-active",
            onUpdate: function(scroll_trigger_self) {
              var currentStep = 1;
              for (var i = 1; i <= steps-1; i++) {
                if (scroll_trigger_self.progress >= (1 / steps * i)) {
                  currentStep = i+1;
                }
              }
              self.find('.swiper-container').data('carousel').swiper.slideTo(currentStep-1)
            }
          });
      }
    } else {
      ScrollTrigger.getAll().forEach(function (self) {
        self.kill();
      });
    }
  }
  self.initHorizontalVeggies();


  return function() {
    $(window).on('resize orientationchange load', self.initHorizontalVeggies)
    return self
  }()
};
